import React from 'react';
import { Stack } from '../../../atoms/stack/Stack';
import { Row } from '../../../atoms/row/Row';
import { Typography } from '../../../atoms/typography/Typography';
import StarRating from '../../shared/starRating/StarRating';
import { LinkButton } from '../../../atoms/linkButton/LinkButton';

const AlternativeItemsHidden = ({ data, category, showMore = false, t }) => {
  const fadedItems = data?.slice(0, 3);
  const hiddenItems = data?.slice(fadedItems?.length);

  return (
    <>
      {fadedItems?.map((alt) => (
        <Stack
          className="flex-1 bg-white rounded-2xl border border-customGray-200 p-6 gap-4"
          key={alt?.id}
        >
          <div
            className="absolute bottom-0 left-0 w-full h-32 bg-gradient-to-t from-white to-transparent"
            key={`${alt?.id}-gradient`}
          />
          <Row className="w-full py-2 items-center gap-4">
            <img
              className="w-[60px] h-[60px] min-w-[60px]"
              src={alt.imgUrl}
              alt={alt.name}
            />
            <Stack className="flex-1 h-full items-start justify-between py-2 gap-1 max-h-18">
              <Typography
                className="overflow-hidden line-clamp-2"
                textAlign="left"
                fontVariant="h7"
              >
                {alt.name}
              </Typography>
            </Stack>
          </Row>
        </Stack>
      ))}
      {hiddenItems?.map((alt) => (
        <div className={'hidden'} key={alt?.id}>
          {alt.name}
        </div>
      ))}
    </>
  );
};

export default AlternativeItemsHidden;
